export default __webpack_public_path__ + "static/dia-c5511748e936028e48f637c61acbb351.png";